import { z } from 'zod'

import type { PortalProfile } from '@portal/portal-api'

import { getPaymentProviderOverride } from '@/shared/config'

const PaymentProviderSchema = z.enum(['adyen', 'xsolla', 'coda'])

export type PaymentProvider = z.infer<typeof PaymentProviderSchema>

export function resolvePaymentProvider(profile: PortalProfile | null | undefined): PaymentProvider {
    const override = getPaymentProviderOverride(profile?.tester ?? false)
    const provider = override ?? profile?.paymentProvider ?? 'adyen'

    return PaymentProviderSchema.parse(provider)
}
